import request from "@/utils/request";
// 拍卖详情
export function getActionInfo(params) {
  return request({
    url: "/auctionInfo/detail",
    method: "get",
    params,
  });
}
// 拍卖详情传参
export function getQueryActionInfo(params) {
  return request({
    url: "/auctionInfo/detailById",
    method: "get",
    params,
  });
}

// 记录参与次数
export function recordViewCount(data) {
  return request({
    url: "/auctionInfo/participantsNumber",
    method: "post",
    data,
  });
}
// 立即报价
export function placeBid(data) {
  return request({
    url: "/check/auctionBidInfo/bid",
    method: "post",
    data,
  });
}
// 报价列表
export function getBidList(params) {
  return request({
    url: "/check/auctionBidInfo/list",
    method: "get",
    params,
  });
}
// 确认报价列表
export function getconfirmBidList(params) {
  return request({
    url: "/check/auctionBidInfo/confirmedList",
    method: "get",
    params,
  });
}
// 日志列表
export function getLogList(params) {
  return request({
    url: "/check/auctionBidInfo/logList",
    method: "get",
    params,
  });
}
// 二维码海报分享
export function gethaibaoCode(params) {
  return request({
    url: "/wechat/generateWechatQrCode",
    method: "get",
    params,
  });
}
// 个人中心我的拍卖列表
export function getUserActionList(params) {
  return request({
    url: "/check/auctionBidInfo/page",
    method: "get",
    params,
  });
}

// 出价详情
export function getbidAutionsDetail(params) {
  return request({
    url: "/check/auctionBidInfo/bidDetail",
    method: "get",
    params,
  });
}

// 是否绑定微信id
export function isBindWeixin(params) {
  return request({
    url: "/wechat/isBind",
    method: "get",
    params,
  });
}

// 绑定微信
export function bindWeixin(params) {
  return request({
    url: "/wechat/generateWechatQrCodeByUser",
    method: "get",
    params,
  });
}

// 解绑微信
export function unbindWeixin(data) {
  return request({
    url: "/wechat/unBindService",
    method: "post",
    data,
  });
}
// 获取带参数的二维码-有用户信息  二维码参数：auctionStartNotify_1（拍卖开始提醒），changeBindUser，bindUser
export function getWeixinQrCodeWithUser(params) {
  return request({
    url: "/wechat/generateWechatQrCodeByUser",
    method: "get",
    params,
  });
}

// 用户通知信息-拍卖开始提醒
export function getUserNotifyInfo(params) {
  return request({
    url: "/check/userNotice/auctionStartNotice",
    method: "get",
    params,
  });
}

// 用户通知信息-取消拍卖开始提醒
export function cancelUserNotifyInfo(data) {
  return request({
    url: "/check/userNotice/cancelAuctionStartNotice",
    method: "post",
    data,
  });
}

// 用户通知信息-设置拍卖开始提醒
export function setUserNotifyInfo(data) {
  return request({
    url: "/check/userNotice/setAuctionStartNotice",
    method: "post",
    data,
  });
}
